import { useCallback, useState, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { DEBOUNCE_DELAY_MS } from '../constants';

const useDebounce = (value = null) => {
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(() => {
    debounceValueSet(value);
  }, [value]);

  const debounceValueSet = useCallback(
    debounce((value) => {
      setDebounceValue(value);
    }, DEBOUNCE_DELAY_MS),
    []
  );

  return debounceValue;
};
// Use Example:

// const [input,setInput]= useState()
//  const debouncedValue = useDebounce(input);

//  useEffect(() => {
// Do Something
// Triggers when "debouncedValue" changes
//  }, [debouncedValue]);

export default useDebounce;
